module.exports = __webpack_public_path__ + "static/media/chokha5.8426ae0f.webp";